import { ProductCategory } from './types';
import ApplicationProtectionLogomark from '../../Logos/Favicons/FaviconApp';
import DataProtectionLogomark from '../../Logos/Favicons/FaviconData';
import EmailProtectionLogomark from '../../Logos/Favicons/FaviconEmail';
import NetworkProtectionLogomark from '../../Logos/Favicons/FaviconNetwork';
import CudaLogomark from '../../Logos/Favicons/FaviconCuda';
import EmailProtectionPromotionalLogomark from '../../Logos/Favicons/FaviconEts';
// eslint-disable-next-line import/prefer-default-export
export const productCategoryIconMap = {
    [ProductCategory.DATA_PROTECTION]: DataProtectionLogomark,
    [ProductCategory.APP_CLOUD_SECURITY]: ApplicationProtectionLogomark,
    [ProductCategory.NETWORK_SECURITY]: NetworkProtectionLogomark,
    [ProductCategory.EMAIL_PROTECTION]: EmailProtectionLogomark,
    [ProductCategory.EMAIL_PROTECTION_PROMOTIONAL]: EmailProtectionPromotionalLogomark,
    [ProductCategory.APP_CLOUD_SECURITY_PROMOTIONAL]: EmailProtectionPromotionalLogomark,
    [ProductCategory.MISCELLANEOUS]: CudaLogomark
};
//# sourceMappingURL=constants.js.map